import React, { useEffect } from 'react';
import "../../styles/home/youtube-video.css";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
import { Link } from 'react-router-dom';



const YoutubeVideo = () => {
    useEffect(() => {

    Fancybox.bind("[data-fancybox='campus-gallery']", {
        infinite: false,
        loop: true,
    });

}, []);


    useEffect(() => {
        // Load YouTube IFrame API
        const script = document.createElement('script');
        script.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(script);

        // Function to initialize the player
        const initializePlayer = () => {
            const player = new window.YT.Player("player", {
                height: "430",
                width: "100%",
                // videoId: "fGP69IzpMpk",
                // videoId: "EhsFCa6ayA8",
                // videoId: "e-lCs3vDQqQ",
                videoId: "rtvrPkMErYo",
                
                events: {
                    onReady: onPlayerReady,
                    onStateChange: onPlayerStateChange,
                },
            });
            return player;
        };

        const onPlayerReady = (event) => {
            // Optional: Autoplay the video when ready
            // event.target.playVideo();
        };

        const onPlayerStateChange = (event) => {
            if (event.data === window.YT.PlayerState.ENDED) {
                event.target.playVideo(); // Replay the video when it ends
            }
        };

        // Cleanup function to remove the script and stop the player
        const cleanupPlayer = () => {
            const playerElement = document.getElementById("player");
            if (playerElement) {
                playerElement.innerHTML = ''; // Clear the player element
            }
        };

        // Event listener for the visibility change
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                const playerInstance = window.YT.get('player');
                if (playerInstance) {
                    playerInstance.pauseVideo(); // Pause when hidden
                }
            } 
            // else if (document.visibilityState === 'visible') {
            //     const playerInstance = window.YT.get('player');
            //     if (playerInstance) {
            //         playerInstance.playVideo(); // Resume when visible
            //     }
            // }
        };

        // Listen for visibility changes
        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Load the player after the script is ready
        window.onYouTubeIframeAPIReady = initializePlayer;

        // Cleanup
        return () => {
            cleanupPlayer();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    return (
        <div className="faq">
            <div className="container main-box">
                <div className="back d-flex align-items-center">
                    <div className="col-lg-6 col-sm-12 box" style={{ paddingRight: 30 }}>
                        <div className="video-sec" id="player" />
                    </div>
                    <div
                        className="col-lg-6 col-sm-12 box"
                        style={{
                            borderLeft: "3px solid rgba(128, 128, 128, 0.425)",
                            paddingLeft: 30
                        }}
                    >
                        <div className="top d-flex justify-content-between align-items-center">
                            <h1 className="my-heading">PHOTO GALLERY</h1>
                            <Link to={"/gallery"} className="normal-button">
                                View All
                            </Link>
                        </div>
                        <p />
                        <div className="gallery">
                            <div className="gallery-main">

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/ccsu-1.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/ccsu-1.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/workshop2.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/workshop2.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/ccsu-2.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/ccsu-2.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/34convo-01.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/34convo-01.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/culture2.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/culture2.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/env2.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/env2.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/Gandhi-2oct-02.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/Gandhi-2oct-02.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/vivekanand-jayanti3.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/vivekanand-jayanti3.jpg" alt="" />
                                    </a>
                                </div>

                                <div className="gallery-item">
                                    <a href="../../assets/images/gallery/yoga-270722-01.jpg" data-fancybox="campus-gallery">
                                        <img src="../../assets/images/gallery/yoga-270722-01.jpg" alt="" />
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default YoutubeVideo;



